import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, Tv, MessageSquare, Palette, Search, Megaphone, Plane, Globe, CreditCard, Infinity, Package, Store } from 'lucide-react';
export function SpendEverywhere() {
  const openWhatsApp = () => {
    window.open('https://wa.me/2250700592164', '_blank', 'noopener,noreferrer');
  };
  const platforms = [{
    name: 'Amazon',
    icon: ShoppingCart,
    color: 'text-orange-500',
    bg: 'bg-orange-50',
    border: 'border-orange-100'
  }, {
    name: 'Shein',
    icon: Store,
    color: 'text-pink-600',
    bg: 'bg-pink-50',
    border: 'border-pink-100'
  }, {
    name: 'Alibaba',
    icon: Package,
    color: 'text-orange-600',
    bg: 'bg-orange-50',
    border: 'border-orange-100'
  }, {
    name: 'Netflix',
    icon: Tv,
    color: 'text-red-600',
    bg: 'bg-red-50',
    border: 'border-red-100'
  }, {
    name: 'ChatGPT',
    icon: MessageSquare,
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
    border: 'border-emerald-100'
  }, {
    name: 'Canva Pro',
    icon: Palette,
    color: 'text-blue-500',
    bg: 'bg-blue-50',
    border: 'border-blue-100'
  }, {
    name: 'Google Ads',
    icon: Search,
    color: 'text-blue-600',
    bg: 'bg-blue-50',
    border: 'border-blue-100'
  }, {
    name: 'Meta Ads',
    icon: Megaphone,
    color: 'text-blue-700',
    bg: 'bg-blue-50',
    border: 'border-blue-100'
  }];
  return <section id="features" className="py-20 bg-white" data-id="element-290">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-291">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-292">
          <div className="inline-flex items-center rounded-full px-4 py-2 text-sm font-semibold text-blue-600 bg-blue-50 mb-6 border border-blue-100" data-id="element-293">
            <span className="flex h-2 w-2 rounded-full bg-blue-600 mr-2" data-id="element-294"></span>
            Pour les agences digitales et e-commerces
          </div>
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl mb-4" data-id="element-295">
            Achetez en ligne sans limites avec vos Cartes USD
          </h2>
          <p className="text-xl font-semibold text-gray-900 mb-6" data-id="element-296">
            La solution de paiement pour votre business en ligne
          </p>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-297">
            Avec vos Cartes Virtuelles en dollars US, achetez vos stocks sur
            Amazon, Shein, Alibaba, payez vos publicités Facebook et Google, et
            gérez tous vos abonnements professionnels — sans restrictions ni
            complications.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gradient-to-r from-blue-50 to-emerald-50 rounded-2xl p-8 mb-12 border border-blue-100" data-id="element-298">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-center md:text-left" data-id="element-299">
            <div className="flex items-center justify-center w-20 h-20 bg-white rounded-2xl shadow-lg" data-id="element-300">
              <div className="relative" data-id="element-301">
                <CreditCard className="w-10 h-10 text-blue-600" data-id="element-302" />
                <Infinity className="w-6 h-6 text-emerald-600 absolute -top-2 -right-2" data-id="element-303" />
              </div>
            </div>
            <div className="flex-1" data-id="element-304">
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-305">
                Créez autant de cartes que vous voulez
              </h3>
              <p className="text-gray-700 text-lg" data-id="element-306">
                Générez plusieurs cartes virtuelles pour organiser vos dépenses
                : une pour les achats de stock, une pour les publicités, une
                pour les abonnements. Contrôlez chaque budget séparément.
              </p>
            </div>
          </div>
        </motion.div>

        <div className="bg-gray-50 rounded-3xl p-8 md:p-12 border border-gray-100" data-id="element-307">
          <p className="text-center text-gray-700 font-medium mb-10 text-lg" data-id="element-308">
            Parfait pour les agences digitales et e-commerces qui utilisent :
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-6" data-id="element-309">
            {platforms.map((platform, index) => <motion.div key={platform.name} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className={`flex items-center gap-3 p-4 rounded-xl border ${platform.bg} ${platform.border} transition-transform hover:-translate-y-1`} data-id="element-310">
                <platform.icon className={`w-5 h-5 ${platform.color}`} data-id="element-311" />
                <span className="font-semibold text-gray-900" data-id="element-312">
                  {platform.name}
                </span>
              </motion.div>)}

            <div className="flex items-center gap-3 p-4 rounded-xl border bg-gray-100 border-gray-200" data-id="element-313">
              <Globe className="w-5 h-5 text-gray-600" data-id="element-314" />
              <span className="font-semibold text-gray-900" data-id="element-315">
                Et plus encore...
              </span>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-316">
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-317">
              Transactions sécurisées, recharges instantanées par Wave, et
              contrôle total sur vos budgets professionnels.
            </p>
            <button onClick={openWhatsApp} className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-medium rounded-full text-white bg-blue-600 hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-318">
              Obtenir mes Cartes Virtuelles USD
            </button>
          </div>
        </div>
      </div>
    </section>;
}